/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

import { NativeModules } from 'react-native';
const { JedAIModule } = NativeModules;

export class Onboarding {

    /**
     * Starting onboarding.
     * @returns `Promise` with no parameters.
     */
    start(): Promise<void> {
        return JedAIModule.onboardingStart();
    }

    /**
     * Finish onboarding.
     * @returns `Promise` with no parameters.
     */
    complete(): Promise<void> {
        return JedAIModule.onboardingComplete()
    }

    /**
     * Finish onboarding.
     * @returns `Promise` with no parameters.
     */
    markAsCompleted(): Promise<void> {
        return JedAIModule.onboardingMarkAsCompleted()
    }

    /**
     * Reset onboarding.
     * @returns `Promise` with no parameters.
     */
    reset(): Promise<void> {
        return JedAIModule.onboardingReset();
    }

}